import { useEffect, useState } from 'react';
import type { IUTMParams } from '~/types';

export const useUTMCapture = (): IUTMParams => {
  const [utmParams, setUtmParams] = useState<IUTMParams>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utm: IUTMParams = {};

    if (params.has('utm_source')) utm.utm_source = params.get('utm_source')!;
    if (params.has('utm_medium')) utm.utm_medium = params.get('utm_medium')!;
    if (params.has('utm_campaign')) utm.utm_campaign = params.get('utm_campaign')!;
    if (params.has('utm_term')) utm.utm_term = params.get('utm_term')!;
    if (params.has('utm_content')) utm.utm_content = params.get('utm_content')!;

    setUtmParams(utm);

    // Also store in localStorage as backup
    if (Object.keys(utm).length > 0) {
      localStorage.setItem('utm_params', JSON.stringify(utm));
    }
  }, []);

  return utmParams;
};
